import { Action, Card, SimpleTooltip } from 'corso-admin-ui';
import { isTruthy } from 'corso-types';
import { useState } from 'react';
import Address from '~/components/Address';
import ClipboardButton from '~/components/ClipboardButton';
import { ConciergeCustomerClaimOverview } from '~/components/CustomerClaimOverview';
import { useShippingClaim } from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useCanEditShippingClaim } from '~/features/shippingClaimReview/hooks/useCanEditShippingClaim';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';
import { EditShippingClaimCustomerInfo } from './EditShippingClaimCustomerInfo';

export function ShippingClaimCustomerDetail() {
  const claim = useShippingClaim();
  const canEdit = useCanEditShippingClaim();
  const isCorsoCxAgent = useIsCorsoCxAgent();
  const [showEdit, setShowEdit] = useState(false);

  const { customerEmail, customerName, shippingAddress, originalStoreOrder } =
    claim;
  const showContactInfo = !!customerEmail || !!shippingAddress?.phone;

  return (
    <Card>
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between">
          <Card.Heading>Customer</Card.Heading>
          {canEdit && (
            <Action
              icon="edit"
              variant="ghost"
              accessibilityLabel="Edit Customer"
              onClick={() => setShowEdit(true)}
            />
          )}
        </div>
        <p className="text-xs text-neutral-500">{customerName}</p>

        {isCorsoCxAgent && customerEmail && (
          <div className="flex flex-col gap-1">
            <ConciergeCustomerClaimOverview
              claimId={claim.id}
              claimEmail={customerEmail}
              customerName={customerName ?? undefined}
            />
          </div>
        )}
      </div>

      {showContactInfo && (
        <div className="flex flex-col gap-1">
          <Card.Heading>Contact information</Card.Heading>
          <div className="flex items-center justify-between">
            <p className="text-xs text-neutral-500">{customerEmail}</p>

            <ClipboardButton
              variant="ghost"
              onClick={() => customerEmail ?? ''}
            />
          </div>
          <p className="text-xs text-neutral-500">
            {shippingAddress?.phone ?? 'No phone'}
          </p>
        </div>
      )}

      {/* todo: fix as child tab index */}
      {shippingAddress && (
        <div className="flex flex-col gap-1">
          <Card.Line>
            <SimpleTooltip
              asChild
              content={
                originalStoreOrder.shippingAddress ? (
                  <div className="flex flex-col gap-1 py-2">
                    <Card.Heading>Order shipping address</Card.Heading>
                    <Address address={originalStoreOrder.shippingAddress} />
                  </div>
                ) : (
                  'No order shipping address'
                )
              }
            >
              <div className="cursor-default">
                <Card.Heading>Shipping address</Card.Heading>
              </div>
            </SimpleTooltip>
            <ClipboardButton
              variant="ghost"
              onClick={() =>
                [
                  shippingAddress.line1,
                  shippingAddress.line2,
                  [
                    shippingAddress.city,
                    shippingAddress.stateOrProvinceCode,
                    shippingAddress.postalCode,
                  ]
                    .filter(isTruthy)
                    .join(' '),
                  shippingAddress.countryCode,
                ]
                  .filter(isTruthy)
                  .join('\n')
              }
            />
          </Card.Line>
          <Address address={shippingAddress} />
        </div>
      )}

      {canEdit && (
        <EditShippingClaimCustomerInfo
          show={showEdit}
          onClose={() => setShowEdit(false)}
        />
      )}
    </Card>
  );
}
